// Visitors' Book: the tools that work on top of the board (assets/ad-vb-board.js),
// for templates/page.guestbook.liquid: colour picker, felt tip, text, line,
// freehand shape, boxes and ovals. While you drag, the shape is drawn on a
// see-through layer over the drawing; when you let go it is painted onto the
// drawing in one go (board.paint), so Undo takes it off again.
// Text stays loose until it is put down: drag its dotted edge to move it and
// its corner to size it, then Enter (or a click on the drawing) puts it down.
// All of them go down at the opacity set on the bar (ui.alpha).
// window.ADBoardTools(board, canvas, ui) returns { use(tool) }, true when the
// tool is one of these (from then on these handle the pointer), update() for
// a new colour, size or opacity, and finish() to put down any loose text.
window.ADBoardTools = (board, cvs, ui) => {
  const W = cvs.width, H = cvs.height, K = H / 480;
  const OWN = ['pick', 'marker', 'text', 'line', 'shape', 'rect', 'rectf', 'oval', 'ovalf'];
  const wrap = cvs.parentNode, ov = document.createElement('canvas'), g = ov.getContext('2d');
  ov.width = W; ov.height = H; ov.className = 'vbOver';
  wrap.append(ov);
  let tool = null, pts = null, colour = '#000000', typing = null;
  const at = (e) => { const r = cvs.getBoundingClientRect(); return [(e.clientX - r.left) * W / r.width, (e.clientY - r.top) * H / r.height]; };
  const nib = () => (ui.size() * 0.8 + 2) * K;
  // (the layer sits exactly over the drawing, inside its edge)
  const lay = () => Object.assign(ov.style, { left: (cvs.offsetLeft + cvs.clientLeft) + 'px', top: (cvs.offsetTop + cvs.clientTop) + 'px', width: cvs.clientWidth + 'px', height: cvs.clientHeight + 'px' });

  // the shape so far, on the layer while dragging and on the drawing at the end
  const draw = (c, t, p) => {
    const [a, b] = [p[0], p[p.length - 1]], x = Math.min(a[0], b[0]), y = Math.min(a[1], b[1]), w = Math.abs(b[0] - a[0]), h = Math.abs(b[1] - a[1]);
    c.save();
    c.globalAlpha = ui.alpha();
    c.strokeStyle = c.fillStyle = colour; c.lineWidth = nib(); c.lineCap = c.lineJoin = 'round';
    c.beginPath();
    if (t === 'line') { c.moveTo(a[0], a[1]); c.lineTo(b[0], b[1]); c.stroke(); }
    else if (t === 'rect' || t === 'rectf') { c.lineJoin = 'miter'; c.rect(x, y, w, h); if (t === 'rectf') c.fill(); else c.stroke(); }
    else if (t === 'oval' || t === 'ovalf') { c.ellipse(x + w / 2, y + h / 2, w / 2, h / 2, 0, 0, 6.2832); if (t === 'ovalf') c.fill(); else c.stroke(); }
    else {
      p.forEach(([u, v], i) => (i ? c.lineTo(u, v) : c.moveTo(u, v)));
      if (t === 'shape') { c.closePath(); c.fill(); }
      else { c.globalAlpha *= 0.55; c.lineWidth = nib() * 1.5; if (p.length < 2) c.lineTo(a[0] + 0.01, a[1]); c.stroke(); }
    }
    c.restore();
  };
  // (Shift keeps boxes and ovals square and lines to 45 degrees)
  const keep = (a, b, e) => {
    if (!e.shiftKey) return b;
    const dx = b[0] - a[0], dy = b[1] - a[1];
    if (tool === 'line') {
      const ang = Math.round(Math.atan2(dy, dx) / 0.7854) * 0.7854, len = Math.hypot(dx, dy);
      return [a[0] + Math.cos(ang) * len, a[1] + Math.sin(ang) * len];
    }
    const m = Math.max(Math.abs(dx), Math.abs(dy));
    return [a[0] + Math.sign(dx || 1) * m, a[1] + Math.sign(dy || 1) * m];
  };

  // the colour picker: takes the colour under the pointer, then goes back to the tool before
  const pick = ([x, y]) => {
    const d = cvs.getContext('2d').getImageData(Math.max(0, Math.min(W - 1, Math.floor(x))), Math.max(0, Math.min(H - 1, Math.floor(y))), 1, 1).data;
    ui.setColour('#' + [d[0], d[1], d[2]].map((v) => v.toString(16).padStart(2, '0')).join(''));
    ui.back();
  };
  // text: a box to type in where you click, loose until it's put down
  const font = (n) => 'bold ' + n + 'px "Times New Roman", Times, serif';
  const write = (p) => {
    let [x, y] = p, px = Math.round((ui.size() * 1.2 + 14) * K), col = colour, op = ui.alpha();
    const box = document.createElement('div'), inp = document.createElement('input'), grip = document.createElement('i');
    box.className = 'vbTextBox'; box.title = 'Drag to move';
    inp.maxLength = 80; inp.setAttribute('aria-label', 'Text');
    grip.className = 'grip'; grip.title = 'Drag to make it bigger or smaller';
    box.append(inp, grip);
    wrap.append(box);
    // (where it sits: the box's dotted edge is 6px outside the text)
    const place = () => {
      const s = cvs.clientWidth / W, ox = cvs.offsetLeft + cvs.clientLeft, oy = cvs.offsetTop + cvs.clientTop;
      g.font = font(px);
      const tw = Math.max(px * 0.5, g.measureText(inp.value).width);
      Object.assign(box.style, { left: (ox + x * s - 6) + 'px', top: (oy + (y - px / 2) * s - 6) + 'px' });
      Object.assign(inp.style, { width: (tw * s + 3) + 'px', height: px * s + 'px', lineHeight: px * s + 'px', fontSize: px * s + 'px', color: col, opacity: op });
    };
    place();
    setTimeout(() => inp.focus());
    inp.addEventListener('input', place);
    // drag the edge to move it, the corner to size it
    box.addEventListener('pointerdown', (e) => {
      if (e.target === inp || e.button > 0) return;
      e.preventDefault(); e.stopPropagation();
      const s = cvs.clientWidth / W, sx = e.clientX, sy = e.clientY, x0 = x, y0 = y, p0 = px, sizing = e.target === grip;
      const w0 = box.offsetWidth, h0 = box.offsetHeight;
      box.setPointerCapture(e.pointerId);
      const mv = (ev) => {
        if (sizing) px = Math.max(8 * K, Math.min(240 * K, p0 * (1 + (ev.clientX - sx + ev.clientY - sy) / (w0 + h0))));
        else { x = x0 + (ev.clientX - sx) / s; y = y0 + (ev.clientY - sy) / s; }
        place();
      };
      const end = () => { box.removeEventListener('pointermove', mv); box.removeEventListener('pointerup', end); box.removeEventListener('pointercancel', end); inp.focus(); };
      box.addEventListener('pointermove', mv); box.addEventListener('pointerup', end); box.addEventListener('pointercancel', end);
    });
    const done = (keep) => {
      if (typing !== done) return;
      typing = null;
      const v = inp.value.trim();
      box.remove();
      if (keep && v) board.paint((c) => { c.globalAlpha = op; c.fillStyle = col; c.font = font(px); c.textBaseline = 'middle'; c.fillText(v, x, y); });
    };
    done.update = () => { col = ui.colour(); op = ui.alpha(); px = Math.round((ui.size() * 1.2 + 14) * K); place(); };
    typing = done;
    inp.addEventListener('keydown', (e) => { if (e.key === 'Enter') done(true); else if (e.key === 'Escape') done(false); });
  };

  wrap.addEventListener('pointerdown', (e) => {
    if (!tool || e.button > 0 || e.target !== cvs) return;
    e.stopPropagation(); e.preventDefault();
    // (a click on the drawing puts down any loose text first)
    if (typing) { typing(true); if (tool === 'text') return; }
    colour = ui.colour();
    const p = at(e);
    if (tool === 'pick') return pick(p);
    if (tool === 'text') return write(p);
    wrap.setPointerCapture(e.pointerId);
    lay();
    pts = [p, p];
    ov.style.mixBlendMode = tool === 'marker' ? 'multiply' : '';
    if (tool === 'marker') { pts = [p]; draw(g, tool, pts); }
  }, true);
  wrap.addEventListener('pointermove', (e) => {
    if (!pts) return;
    const p = at(e);
    if (tool === 'marker' || tool === 'shape') pts.push(p);
    else pts[1] = keep(pts[0], p, e);
    g.clearRect(0, 0, W, H);
    draw(g, tool, pts);
  });
  const up = () => {
    if (!pts) return;
    const p = pts, t = tool;
    pts = null;
    g.clearRect(0, 0, W, H);
    const moved = p.some((q) => Math.hypot(q[0] - p[0][0], q[1] - p[0][1]) > 2 * K);
    if (moved || t === 'marker') board.paint((c) => { if (t === 'marker') c.globalCompositeOperation = 'multiply'; draw(c, t, p); });
  };
  wrap.addEventListener('pointerup', up);
  wrap.addEventListener('pointercancel', up);

  return {
    use(t) {
      if (typing) typing(true);
      tool = OWN.includes(t) ? t : null;
      cvs.style.cursor = tool === 'text' ? 'text' : '';
      return !!tool;
    },
    update() { if (typing) typing.update(); },
    finish() { if (typing) typing(true); }
  };
};